// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ota-p14[data-v-0025533e]{font-size:1.4rem!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
